import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import Spin from 'components/common/Spin';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  inputContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  textField: {
    '& .MuiInputBase-root': {
      borderRadius: 30,
      paddingRight: 40,
      paddingLeft: 16,
    },
  },
  btn: {
    position: 'absolute',
    right: 10,
  },
  center: {
    textAlign: 'center',
  },
  signature: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 8,
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Composer = ({ addNote }) => {
  const classes = useStyles();
  const [value, setValue] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = () => {
    if (value) {
      setSaving(true);
      return addNote(value).then((resp) => {
        setSaving(false);
        if (resp) {
          setValue('');
        }
      });
    }
  };

  return (
    <div className={classes.root}>
      <Grid sm={12} item className={classes.inputContainer}>
        <TextField
          multiline
          fullWidth
          margin="none"
          size="large"
          variant="outlined"
          classes={{
            root: classes.textField,
          }}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <IconButton
          disabled={saving || !value}
          className={classes.btn}
          size="small"
          onClick={handleSubmit}
        >
          {saving ? <Spin spinning /> : <SendIcon color="primary" />}
        </IconButton>
      </Grid>
    </div>
  );
};

export default Composer;
